<template>
    <div class="app-loading" v-if="loading && shouldShowLoading">
        <div class="text-center">
            <Preloader />
        </div>
    </div>
</template>

<script>
import Preloader from '@/components/app/Preloader'

export default {
    components: { Preloader },
    data: () => ({
        shouldShowLoading: false,
    }),
    watch: {
        loading() {
            this.shouldShowLoading = false
            if (this.loading) {
                setTimeout(() => {
                    this.shouldShowLoading = true
                }, 150)
            }
        },
    },
    computed: {
        loading() {
            return this.$store.getters.loading.global
        },
    },
}
</script>

<style scoped>
.app-loading {
    position: fixed;
    top: 0px;
    bottom: 0px;
    left: 0px;
    right: 0px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    background-color: rgba(255, 255, 255, 0.6);
    z-index: 20;
}
</style>
